export default __webpack_public_path__ + "lora-cloud.0f77fe255ed86553dc3f652a1a6591e0.png";